import React, { Component } from 'react'
import RadioInput from '../RadioInput/RadioInput'
import Embedded from './Embedded'
import NpsRating from './NpsRating'

class Rating extends Component {
  render() {
    switch (this.props.sub_type) {
      case 'star':
        return <NpsRating {...this.props} thumbnail_type="star" />
      case 'score':
        return <p></p>
      // return <NpsInput {...this.props}/>;
      case 'nps':
        return <RadioInput type="nps" {...this.props} />
      case 'like_dislike':
        return <RadioInput type="like_dislike" {...this.props} />
      case 'embeded':
        return <Embedded {...this.props} />
      default:
        throw Error('Field type is not recognized')
    }
  }
}

export default Rating
